import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ClientProfileState } from './diet.models';

export const selectClientFeature =
  createFeatureSelector<ClientProfileState>('client');

export const selectAllClients = createSelector(
  selectClientFeature,
  (state) => state.clients
);

export const selectClientsLoading = createSelector(
  selectClientFeature,
  (state) => state.loading
);

export const selectSelectedClient = createSelector(
  selectClientFeature,
  (state) => state.selectedClient
);
